import { render, staticRenderFns } from "./YouthScene.vue?vue&type=template&id=70497e4a&"
import script from "./YouthScene.vue?vue&type=script&lang=js&"
export * from "./YouthScene.vue?vue&type=script&lang=js&"
import style0 from "./YouthScene.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports